import { StatusStyleCode } from '../common';
import { ApiEntityStatus } from './common.types'

export enum ErpOrderStatusCode {
    New = '-2', // new
    Work = '0', // work
    Completed = '2', //completed
}

export const ErpOrderStatusSpec: { [key in ErpOrderStatusCode]: Omit<ApiEntityStatus, 'code'> } = {
    [ErpOrderStatusCode.New]: { id: -2, name: 'Новый', color: StatusStyleCode.Blue },
    [ErpOrderStatusCode.Work]: { id: 0, name: 'В работе', color: StatusStyleCode.Yellow },
    [ErpOrderStatusCode.Completed]: { id: 2, name: 'Завершен', color: StatusStyleCode.Green },
}


